import React from "react";
import Box from "@mui/material/Box";
import { Typography, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import { useAuthStore } from "../store/useAuthStore";

const SideMenu = () => {
  const Heading = {
    fontFamily: `"Quicksand", sans-serif`,
    fontWeight: 700,
    fontSize: { xs: "16px", md: "16px", lg: "16px" },
    lineHeight: "24px",
    color: "#000000",
    textAlign: "left",
    textTransform: "uppercase",
  };
  const { logout } = useAuthStore()
  const handleLogout = async () => {
    try {
      await logout()
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        textAlign:"left",
        background:"#fff",
        padding:"12px 20px 10px",
        borderRadius: 1,
         boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        "& ul": {
          padding: 0,
          marginTop: "0px",
          marginBottom: "0px",
        },
        "& .TopBreadcrumbList li": {
          display: "block",
          alignItems: "center",
          fontSize: "16px",
          lineHeight: "28px",
          fontWeight: "400",
          fontFamily: `"Lato", sans-serif`,
          color: "#808080",
          marginBottom:"5px",
        },
        "& .TopBreadcrumbList li a": {
          color: "#808080",
        },
        "& .TopBreadcrumbList li.active a": {
          color: "#008BFF",
          display: "flex",
          alignItems: "center",
          textDecoration: "none",
        },
      }}
    >
      <div>
        {/* <Typography variant="h4" sx={Heading}>
          Manage My Account
        </Typography> */}
        <ul className="TopBreadcrumbList">

          <li>
            <Link to="/account">My Profile</Link>
          </li>
          <li>
            <Link to="/resetpassword">Manage Password</Link>
          </li>

        </ul>
        {/* <Typography variant="h4" sx={Heading}>
          My Orders
        </Typography> */}
        <ul className="TopBreadcrumbList">
          <li>
           <Link to="/orders">Orders</Link>
          </li>
          <li>
            <a href="/">My Returns</a>
          </li>
          <li>
            <a href="/">My Cancellations</a>
          </li>
        </ul>
        <Divider sx={{ my: 1 }} />
        <ul className="TopBreadcrumbList">
          <li>
            <button
              style={{
                border: "none",
                outline: "none",
                background: "none",
                cursor: "pointer"
              }}
              onClick={handleLogout}
            >
              Logout
            </button>
          </li>
        </ul>
        {/* <Typography variant="h4" sx={Heading}>
          My WishList
        </Typography> */}
      </div>
    </Box>
  );
};

export default SideMenu;
